import { PunchupEventSummaryTile } from 'features/common/components/Punchup/primitives/display/PunchupEventSummaryTile';

import { SendTicketsTitleSectionProps } from '../../types';

/**
 * SendTickets adapter over the shared `PunchupEventSummaryTile`: formats this feature's `days[]` shape into a
 * `dateLabel` and renders the shared show-summary tile (same visual as the Scan-Tickets header). The tile owns
 * the layout; this adapter owns only the SendTickets date formatting.
 */
export const PunchupSendTicketsTitleSection = ({ title, days, streetAddress }: SendTicketsTitleSectionProps) => {
	const dateLabel = !days?.length
		? undefined
		: days.length > 1
		? `${days[0].day.label} – ${days[days.length - 1].day.label}`
		: `${days[0].day.label} · ${days[0].time.label}`;

	return <PunchupEventSummaryTile title={title} dateLabel={dateLabel} location={streetAddress || undefined} />;
};
